<template>
  <div>
    <br>
    <br>
    <br>
    <div class="big">
      <span style="float: left"> {{ decodeHTML(report_info.last_name) }}, {{ decodeHTML(report_info.rank_name) }}
        <br>
        <select title="Here you must fill in the position in which you flew in the Patrula."
          v-model="report_patrula_pos">
          <option v-for="(patrula_pos, index) in patrulaPosStatus" v-bind:value="index">
            {{ patrula_pos }}
          </option>
        </select>
        <select title="Here you must fill in which Patrula you flew in." v-model="report_patrula">
          <option v-for="(patrula, index) in patrulaStatus" v-bind:value="index">
            {{ patrula }}
          </option>
        </select>,
        <select title="Here you must fill in your unit." v-model="report_unit">
          <option v-for="d_unit in unitsByFaction(6)" v-bind:value="d_unit.depl_unit_id">
            {{ d_unit.hist_unit_name }}
          </option>
        </select>
        <br>
        <select title="Here you must fill in your aircraft." v-model="report_aircraft">
          <option :value="null" disabled>Select aircraft</option>
          <option v-for="aircraft in assetByFactionControllable(6, 1)" v-bind:value="aircraft.id">
            {{ aircraft.name }}
          </option>
        </select>
        /
        <input title="Here you must fill in the markings of your aircraft." placeholder="Markings"
          v-model="report_markings">
      </span>
      <span style="float: right">
        <input title="Here you must fill in the base which you took off from." placeholder="Airfield"
          v-model="report_aerodrome">
        la {{ decodeHTML(report_info.mission_hist_date) }}
      </span>
    </div>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <div class="biggerCenter">
      <span style="text-decoration: underline">Raport de lupta</span>
    </div>
    <br>
    <br>
    <div class="bigFARRText">
      <span>Spre zborul inamicului {{ decodeHTML(report_info.abreviation) }} {{ decodeHTML(report_info.last_name) }},
        scris in camp pe {{ decodeHTML(report_info.mission_hist_date) }}. Daca nu urmeaza nimic aici, nimic nu este
        inchis a raporta.</span>
    </div>
    <div class="bigFARRText">
      <textarea title="Here you can fill in a short synopsis for your sortie. If you are claiming any victories in the section below,
         this field is mandatory. You may insert screenshots with the [img]img-url[/img] tags."
        placeholder="Synopsis (optional)" v-model="report_synopsis" class="textarea-style"></textarea>
    </div>
    <div>
      <span style="margin-left: 15%" class="bigSignature">
        {{ decodeHTML(report_info.abreviation) }}
        {{ decodeHTML(report_info.first_name) }}
        {{ decodeHTML(report_info.last_name) }}
      </span>
    </div>
    <div>
      <span class="bigLeft">
        {{ decodeHTML(report_info.first_name) }}
        '{{ report_info.callsign }}'
        {{ decodeHTML(report_info.last_name) }},
        {{ decodeHTML(report_info.rank_name) }}
      </span>
    </div>
    <br>
    <br>
    <br>
  </div>
</template>

<script>
import statConv from "../../resource/statusConverter"
import stringConv from "../../resource/stringConverter"
import EditClaimFARR from "./EditClaimFARR"
import EditClaimGround from "./EditClaimGround"
import Comment from "./Comment"
import { mapState, mapGetters } from "vuex"

export default {
  name: "EditReportFARR",
  components: {
    EditClaimFARR,
    EditClaimGround,
    Comment
  },
  mixins: [
    stringConv,
    statConv
  ],
  props: {
    first_name: {
      type: String,
      default: null
    },
    last_name: {
      type: String,
      default: null
    },
    callsign: {
      type: String,
      default: null
    },
    rank_name: {
      type: String,
      default: null
    },
  },
  mounted() {

  },
  data() {
    return {

    }
  },
  computed: {

    report_unit: {
      get() {
        return this.report_info.depl_unit_id;
      },
      set(value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report",
            update_column_name: "depl_unit_id",
            update_column_value: value
          });
      }
    },

    report_patrula: {
      get() {
        var patrula = this.report_details.patrula;
        return patrula === undefined ? 4 : patrula;
      },
      set(value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report_details",
            update_column_name: "patrula",
            update_column_value: value
          });
      }
    },

    report_patrula_pos: {
      get() {
        var patrula_pos = this.report_details.patrula_pos;
        return patrula_pos === undefined ? 4 : patrula_pos;
      },
      set(value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report_details",
            update_column_name: "patrula_pos",
            update_column_value: value
          });
      }
    },

    report_aircraft: {
      get() {
        return this.report_info.asset_id;
      },
      set(value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report",
            update_column_name: "asset_id",
            update_column_value: value
          });
      }
    },

    report_markings: {
      get() {
        return this.report_info.markings;
      },
      set(value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report",
            update_column_name: "markings",
            update_column_value: value
          });
      }
    },

    report_aerodrome: {
      get() {
        return this.report_info.base;
      },
      set(value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report",
            update_column_name: "base",
            update_column_value: value
          });
      }
    },

    report_pilot_status: {
      get() {
        var pilot_status = this.report_info.pilot_status;
        return pilot_status === undefined ? 0 : pilot_status;
      },
      set(value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report",
            update_column_name: "pilot_status",
            update_column_value: value
          });
      }
    },

    report_asset_status: {
      get() {
        var asset_status = this.report_info.asset_status;
        return asset_status === undefined ? 0 : asset_status;
      },
      set(value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report",
            update_column_name: "asset_status",
            update_column_value: value
          });
      }
    },

    report_synopsis: {
      get() {
        return this.report_info.synopsis;
      },
      set(value) {
        this.$store.commit('missionStore/updateReportValue',
          {
            array_name: "report",
            update_column_name: "synopsis",
            update_column_value: value
          });
      }
    },

    ...mapState("missionStore", {
      report_info: state => state.report,
      report_details: state => state.report_details,
      aerial_claims: state => state.aerial_claims,
      ground_claims: state => state.ground_claims
    }),

    ...mapGetters("missionStore", [
      "unitsByFaction",
      "assetByFactionControllable"
    ])
  },
  methods: {

    addAerialClaim: function () {

      this.$store.commit('missionStore/addAerialClaim',
        {
          report_id: this.report_info.report_id,
          asset_id: null,
          claim_time: null,
          place: null,
          opponent: null,
          fate_of_crew: 0,
          type_of_destruction: 0,
          type_of_impact: 0,
          confirmed: 0,
          witness_id: null
        });
    },

    addGroundClaim: function () {

      this.$store.commit('missionStore/addGroundClaim',
        {
          report_id: this.report_info.report_id,
          asset_id: null,
          amount: 1,
          description: null
        });
    }
  }
}
</script>

<style scoped>
div {
  margin: 5px 0;
}

.textarea-style {
  width: 98%;
  height: 20em;
}


.biggerCenter {
  font-size: x-large;
  text-decoration: underline;
  text-align: center;
}

.bigRight {
  float: right;
  font-size: large;
  margin-right: 15%;
}

.bigLeft {
  font-size: large;
  margin-left: 15%;
}

.big {
  font-size: large;
  margin-left: 8%;
  margin-right: 8%;
}

.bigFARRText {
  font-size: large;
  margin-left: 15%;
  margin-right: 15%;
}
</style>



// WEBPACK FOOTER //
// src/components/campaign/EditReportFARR.vue